import { alt } from "@cirrus-delivery/common/_alt"

class Actions {
  constructor() {
    this.generateActions("locationChanged", "examPageOpened", "errorOccured")
  }
}

export default alt.createActions(Actions)
